export default "__VITE_PUBLIC_ASSET__be0708e8__"